<!-- Tab delle Cabine -->
<section class="detail-section" *ngIf="!brand?.detailPageConfig.showPriceGrid && (shipService$ | async)?.cabins?.length">
  <h4 class="detail-section__title">Cabine</h4>

  <div class="row">
    <!-- Select Cabina -->
    <div class="col-12 mb-3">
      <div class="inline-select">
        <label class="inline-select__label" for="selectCabin">
          <div class="row-icon">
            <div class="row-icon__icon">
              <i class="g-icon-bed"></i>
            </div>
            <div class="row-icon__text">
              Scopri tutte le tipologie di cabina
            </div>
          </div>
        </label>
        <div class="inline-select__select">
          <ng-select [items]="shipDetails.cabins" [(ngModel)]="selectedCabin" bindLabel="typology"
            [searchable]="false" [clearable]="false" placeholder="Seleziona cabina..." id="selectCabin"
            (change)="resetImgIndex($event)">
          </ng-select>
        </div>
      </div>
    </div>

    <!-- Cabina selezionata -->
    <div class="col-12" *ngIf="selectedCabin">
      <div class="card-accomodation">
        <swiper [config]="selectedCabin.images.length === 1 ? singleImgConfig : config" [(index)]="index" class="c-accomodation-slider" *ngIf="selectedCabin.images.length">
          <div class="c-accomodation-slider-item" *ngFor="let image of selectedCabin.images | orderBy: 'type'">
            <div [ngStyle]="{'background-image': 'url(' + (image.image_path | cdnify) + ')'}"
            class="card-accomodation__image"></div>
          </div>
        </swiper>

        <div class="card-accomodation__content">
          <h4 class="c-accomodation-carousel__title">{{selectedCabin.typology}}</h4>
          <span class="card-accomodation__content-passengers">
            <span><i class="icon-user"></i></span>
            <span [innerHTML]="selectedCabin.subtitle"></span>
          </span>
          <span [innerHTML]="selectedCabin.surface"></span>
          <p class="card-accomodation__content-text" [innerHTML]="selectedCabin.description"></p>

          <a dynamicNavigation *ngIf="!isLanding" [href]="bookingUrl"
             class="card-accomodation__content-cta">
            Prosegui per selezionare la tua cabina
          </a>


        </div>

      </div>
    </div>
  </div>

  <div class="wrapper-buttons detail-cta text-center" [ngClass]="{'is-widget' : (isWidget$ | async)}" *ngIf="!isLanding">
    <a class="btn btn--brand-color-03 text-left" dynamicNavigation [href]="bookingUrl">
      <h5>Prosegui</h5>
      <span>verifica disponibilità e prezzo</span>
      <i class="g-icon-chevron-right-circle"></i>
    </a>
  </div>

</section>

<hr class="detail-section__divider" *ngIf="!brand?.detailPageConfig.showPriceGrid && (shipService$ | async)?.cabins?.length">

<!-- Tab dei Ponti -->
<section class="detail-section d-none d-md-block" *ngIf="(shipService$ | async)?.decks?.plant?.length">
  <h4 class="detail-section__title">Ponti</h4>
  <div class="row">
    <!-- Select Ponte -->
    <div class="col-12 mb-3">
      <div class="inline-select">
        <!-- icon + label -->
        <label class="inline-select__label" for="selectDeck">
          <div class="row-icon">
            <div class="row-icon__icon">
              <i class="g-icon-cruise-search"></i>
            </div>
            <div class="row-icon__text">
              Seleziona un ponte
            </div>
          </div>
        </label>
        <!-- text -->
        <div class="inline-select__select">
          <ng-select [items]="(shipService$ | async).decks.plant" [(ngModel)]="selectedDeck" bindLabel="name"
            [searchable]="false" [clearable]="false" placeholder="Seleziona ponte..." id="selectDeck">
          </ng-select>
        </div>
      </div>
    </div>
    <!-- Dettagli Ponte -->
    <div class="col-12" *ngIf="selectedDeck">
      <div class="detail-content__selected-deck">
        <lib-ngx-image-zoom [magnification]="1" [circularLens]="true" [enableLens]="true"
          [thumbImage]="selectedDeck.image_path" [fullImage]="selectedDeck.image_path"></lib-ngx-image-zoom>
      </div>
      <!-- Legenda -->
      <div class="detail-content__legend" *ngIf="(shipService$ | async)?.legend || (shipService$ | async)?.cabinLegend">
        <a (click)="showLegend = !showLegend">
          <span *ngIf="!showLegend">Visualizza Legenda</span>
          <span *ngIf="showLegend">Nascondi Legenda</span>
        </a>
        <div class="detail-content__legend-content" *ngIf="showLegend">
          <div class="detail-content__legend-container" *ngIf="(shipService$ | async)?.cabinLegend">
            <div class="detail-content__legend-block"
              *ngFor="let category of (shipService$ | async)?.cabinLegend | keyvalue">
              <span class="detail-content__legend-title">Cabine {{category.key}}</span>
              <div class="detail-content__legend-item" *ngFor="let cabin of category.value">
                <div class="detail-content__legend-color"
                  [ngStyle]="{'background-color': cabin.color ? cabin.color: '#ccc'}"></div>
                <div class="detail-content__legend-cabin">
                  <span>{{cabin.typology}}</span>
                </div>
              </div>
            </div>
          </div>
          <ul class="detail-content__legend-list" *ngIf="(shipService$ | async)?.legend">
            <li *ngFor="let legendItem of (shipService$ | async)?.legend">
              <div class="detail-content__legend-list--img">
                <img height="12" width="12" class="img-contain" [src]="legendItem.image_path | cdnify" [hideImageOnError]="true" alt="icona-legenda">
              </div>
              <span>{{legendItem.description}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Schema nave -->
    <div class="col-12" *ngIf="(shipService$ | async)?.decks?.front?.length">
      <img class="ship__scheme" alt="ponti nave" *ngIf="(shipService$ | async)?.decks.front[0]"
        [src]="(shipService$ | async).decks.front[0].image_path" [hideImageOnError]="true" width="100%">
    </div>

  </div>

</section>

<hr class="detail-section__divider" *ngIf="(shipService$ | async)?.decks?.plant?.length">

<!-- Tab descrizione Nave -->
<section class="detail-section">
  <h4 class="detail-section__title">La Nave</h4>

  <div class="ship__info">
    <!-- Nome nave -->
    <div class="row-icon ship__name">
      <div class="row-icon__icon">
        <i class="icon-cruise"></i>
      </div>
      <div class="row-icon__text">
        {{(cruise$ | async)?.ship.name}}
      </div>
    </div>
    <!-- Descrizione nave -->
    <p class="ship__description" [innerHTML]="(shipService$ | async)?.info?.description"></p>

  </div>

  <!-- Lista specifiche -->
  <ul class="ship__detail-list" *ngIf="(shipService$ | async)?.info">

    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.twin">
      <span class="ship__detail-single__label">Nave gemella</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.twin}}</span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.tonnage">
      <span class="ship__detail-single__label">Stazza</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.tonnage}}</span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.length">
      <span class="ship__detail-single__label">Lunghezza</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.length}}</span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.width">
      <span class="ship__detail-single__label">Larghezza</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.width}}</span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.guest_capacity">
      <span class="ship__detail-single__label">Capacità ospiti</span>
      <span class="ship__detail-single__value" [innerHTML]="(shipService$ | async)?.info.guest_capacity"></span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.cabin_number">
      <span class="ship__detail-single__label">Cabine totali</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.cabin_number}}</span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.crew_capacity">
      <span class="ship__detail-single__label">Componenti equipaggio</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.crew_capacity}}</span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.decks_number">
      <span class="ship__detail-single__label">Ponti</span>
      <span class="ship__detail-single__value" [innerHTML]="(shipService$ | async)?.info.decks_number"></span>
    </li>
    <li class="ship__detail-single" *ngIf="(shipService$ | async)?.info.build_info">
      <span class="ship__detail-single__label">Costruzione</span>
      <span class="ship__detail-single__value">{{(shipService$ | async)?.info.build_info}}</span>
    </li>
  </ul>

</section>
